var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center mb-4 md:mb-6 mt-10 px-2 md:mt-16"},[_c('BackIcon',{staticClass:"mr-2"}),_vm._v(" Back ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }